export const SLACK_ICON_URL =
  'https://a.slack-edge.com/80588/marketing/img/meta/slack_hash_256.png';
